import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import {jwtDecode} from "jwt-decode";
import "bootstrap/dist/css/bootstrap.min.css";

// استخراج memberId من JWT token
const getMemberIdFromToken = () => {
    const token = localStorage.getItem("FORCE_GYM_TOKEN");
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded.user_id || decoded.id; // حسب payload في التوكن
    } catch (e) {
        console.error("Invalid token", e);
        return null;
    }
};

export default function MemberChatArabic({ isOpen, setIsOpen, unreadCount, setUnreadCount }) {
    const [memberId, setMemberId] = useState(null);
    const [admin, setAdmin] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");


    const textareaRef = useRef(null);
    const messagesContainerRef = useRef(null);

    useEffect(() => {
        if (!memberId) return;

        const fetchUnread = async () => {
            try {
                const token = localStorage.getItem("FORCE_GYM_TOKEN");
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/messages/unread/${memberId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setUnreadCount(res.data.unreadCount);
            } catch (err) {
                console.error("Error fetching unread count", err);
            }
        };

        fetchUnread();
        const interval = setInterval(fetchUnread, 5000);
        return () => clearInterval(interval);
    }, [memberId]);

    const markAsRead = async () => {
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/messages/read`,
                { sender_id: admin.id, receiver_id: memberId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
        } catch (err) {
            console.error("Failed to mark as read:", err);
        }
    };

    useEffect(() => {
        if (isOpen && admin && memberId) {
            markAsRead();
            setUnreadCount(0);
        }
    }, [isOpen, admin, memberId]);



    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = Math.min(scrollHeight, 134) + "px";
        }
    }, [newMessage]);


    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop =
                messagesContainerRef.current.scrollHeight;
        }
    }, [messages]);



    // استخراج memberId عند تحميل الصفحة
    useEffect(() => {
        const id = getMemberIdFromToken();
        if (id && id !== memberId) {
            setMemberId(id);
        }
    }, [localStorage.getItem("FORCE_GYM_TOKEN")]);


    // جلب بيانات الأدمن (أو الأدمن الأول)
    const fetchAdmin = async () => {
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/members`, {
                headers: {Authorization: `Bearer ${token}`},
            });
            const adminUser = res.data.find(u => u.role === "admin");
            setAdmin(adminUser || null);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!memberId) return;
        fetchAdmin();
    }, [memberId]);

    // جلب الرسائل بين العضو والأدمن
    const fetchMessages = async () => {
        if (!memberId || !admin) return;
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/messages/${memberId}/${admin.id}`,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            setMessages(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!admin) return;

        fetchMessages();
        const interval = setInterval(() => fetchMessages(), 3000);
        return () => clearInterval(interval);
    }, [admin]);

    // إرسال رسالة جديدة
    const sendMessage = async () => {
        if (!newMessage.trim() || !memberId || !admin) return;

        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/messages`,
                {
                    sender_id: memberId,
                    receiver_id: admin.id,
                    message: newMessage,
                },
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            setNewMessage("");
            fetchMessages();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div
            className={`position-fixed bg-white border-start shadow ${
                isOpen ? "d-flex" : "d-none"
            }`}
            style={{
                top: 160,
                zIndex: 2000,
                flexDirection: "column",
                height: "calc(100vh - 250px)",
                borderRadius: "15px",
                // ✅ منطق العرض حسب حجم الشاشة
                width: window.innerWidth <= 768 ? "90%" : "500px", // موبايل أو تابلت
                left: window.innerWidth <= 768 ? "50%" : "auto",   // وسّطه فقط على الموبايل
                transform: window.innerWidth <= 768 ? "translateX(-50%)" : "none",
            }}
        >
            {/* 🔝 الهيدر */}
            <div
                className="d-flex align-items-center p-3 border-bottom bg-light flex-shrink-0 justify-content-between"
                style={{ height: "70px" }}
            >
                <button className="btn-close" onClick={() => setIsOpen(false)}></button>

                <div className="d-flex align-items-center">
                    <div className="text-end me-2">
                        <h6 className="mb-0">The Force Gym</h6>
                        <small className="text-muted">الدعم الفني</small>
                    </div>
                    <img
                        src={"/the_force_gym_logo.jpg"}
                        alt="Admin"
                        className="rounded-circle"
                        width={40}
                        height={40}
                    />
                </div>
            </div>


            <div
                className="p-3 flex-grow-1 overflow-auto"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#fafafa",
                }}
                ref={messagesContainerRef}
            >
                {messages.map((msg) => (
                    <div
                        key={msg.id}
                        className={`d-flex mb-2 ${
                            msg.sender_id === memberId
                                ? "justify-content-start"
                                : "justify-content-end"
                        }`}
                    >
                        <div
                            className="p-3"
                            style={{
                                background: msg.sender_id === memberId
                                    ? "linear-gradient(135deg, #d1e7dd, #b8dfc3)"
                                    : "linear-gradient(135deg, #f8d7da, #f5c6cb)",
                                borderRadius: "20px",
                                maxWidth: "70%",
                                minWidth: "30%",
                                wordBreak: "break-word",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                border: "1px solid rgba(0,0,0,0.05)",
                            }}
                            dir="rtl"
                        >
                            {msg.message}
                            <br />
                            <small
                                className="text-muted"
                                style={{ fontSize: "0.7rem" }}
                            >
                                {new Date(msg.created_at).toLocaleString("ar-EG")}
                            </small>
                        </div>
                    </div>
                ))}
            </div>


            <div
                className="p-3 border-top bg-white d-flex align-items-end flex-shrink-0"
                style={{ height: "auto" }}
            >
  <textarea
      ref={textareaRef}
      className="form-control me-2"
      placeholder="اكتب رسالتك هنا..."
      value={newMessage}
      onChange={(e) => setNewMessage(e.target.value)}
      style={{
          resize: "none",
          overflowY: "auto",
          minHeight: "50px",
          maxHeight: "134px",
          flex: 1,
          borderRadius: "20px",
          border: "1px solid #ced4da",
          padding: "10px 15px",
          fontSize: "0.95rem",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
          backgroundColor: "#f8f9fa",
      }}
      rows={1}
      dir="rtl"
      onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              sendMessage();
          }
      }}
  />

                <button
                    className="btn btn-primary d-flex align-items-center justify-content-center"
                    style={{
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        padding: 0,
                        marginLeft: "5px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    }}
                    onClick={sendMessage}
                >
                    <i className="bi bi-send-fill"></i>
                </button>
            </div>
        </div>
    );
};